import { useState } from 'react';
import { mangaList } from '@/mocks/manga';

const chapterList = ['第 1 话', '第 2 话', '第 3 话', '第 4 话', '第 5 话', '第 6 话', '第 7 话', '第 8 话', '第 9 话', '第 10 话'];

export default function ReadingSection() {
  const featured = mangaList[0];
  const [page, setPage] = useState(2);

  return (
    <section id="reading" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950">
            <i className="ri-book-read-fill text-secondary-500" />
            阅读专区
          </h2>
          <p className="mt-1 text-sm text-foreground-600">体验一下下拉式高清阅读的真实观感</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-700 ring-1 ring-background-200/70 transition hover:text-primary-500"
            aria-label="上一页"
          >
            <i className="ri-arrow-left-line" />
          </button>
          <span className="text-xs text-foreground-600">第 {page} / 10 页</span>
          <button
            onClick={() => setPage((p) => Math.min(10, p + 1))}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-700 ring-1 ring-background-200/70 transition hover:text-primary-500"
            aria-label="下一页"
          >
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <div className="flex items-center justify-between gap-3 rounded-t-lg bg-background-100 px-4 py-3 ring-1 ring-background-200/70">
            <div className="flex items-center gap-2">
              <img
                src={featured.cover}
                alt={`${featured.title} 阅读页封面`}
                className="h-10 w-7 rounded object-cover object-top"
              />
              <div>
                <p className="text-sm font-bold text-foreground-950">{featured.title}</p>
                <p className="text-[11px] text-foreground-600">{chapterList[page - 1]} · 下拉式阅读</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="hidden rounded-full bg-accent-500/15 px-2.5 py-1 text-[11px] text-accent-400 sm:inline">
                高清画质
              </span>
              <span className="hidden rounded-full bg-primary-500/15 px-2.5 py-1 text-[11px] text-primary-400 sm:inline">
                无删减
              </span>
            </div>
          </div>

          <div className="rounded-b-lg bg-background-100 p-4 ring-1 ring-t-0 ring-background-200/70">
            <div className="mx-auto max-w-md overflow-hidden rounded-md">
              <img
                src="https://readdy.ai/api/search-image?query=single%20manga%20comic%20page%20illustration%2C%20hero%20boy%20standing%20confidently%20as%20coral%20red%20flame%20energy%20wraps%20around%20him%2C%20several%20dramatic%20panels%20with%20speech%20bubbles%2C%20dynamic%20action%20sequence%2C%20bold%20ink%20outline%20and%20cell%20shading%2C%20white%20page%20background%2C%20screen%20tones%2C%20speed%20lines%2C%20high%20detail%2C%20clean%20readable%20composition&width=800&height=1200&seq=reading-page-01&orientation=portrait"
                alt={`${featured.title} 第 ${page} 话漫画页`}
                className="w-full object-cover"
              />
            </div>
            <div className="mt-4 flex items-center justify-center gap-3">
              <button
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-200 px-5 py-2 text-sm text-foreground-700 transition hover:text-primary-500"
              >
                <i className="ri-skip-back-fill" /> 上一话
              </button>
              <button
                onClick={() => setPage((p) => Math.min(10, p + 1))}
                className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 transition hover:bg-primary-600"
              >
                下一话 <i className="ri-skip-forward-fill" />
              </button>
            </div>
          </div>
        </div>

        <div className="rounded-lg bg-background-100 p-4 ring-1 ring-background-200/70">
          <h3 className="mb-3 text-sm font-bold text-foreground-950">目录 · {featured.title}</h3>
          <ul className="grid grid-cols-2 gap-2">
            {chapterList.map((c, i) => (
              <li key={c}>
                <button
                  onClick={() => setPage(i + 1)}
                  className={`w-full whitespace-nowrap rounded-md px-3 py-2 text-left text-xs transition ${
                    page === i + 1
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-background-200 text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {c}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}